/*
 * Copyright Deskshare Inc.
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, distribution, or use is strictly prohibited.
 */

import React from "react";
import { useTranslation } from "react-i18next";
import { CART_ICON_SVG_PATH, CART_CIRCLE_1, CART_CIRCLE_2 } from "./constants";

interface CartIconProps {
  href: string;
  className?: string;
  style?: React.CSSProperties;
  /** VM-3: lets the header hand a signed-in customer's sign-in to the shop. */
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
}

const CartIcon: React.FC<CartIconProps> = ({
  href,
  className = "cart-btn",
  style,
  onClick,
}) => {
  const { t } = useTranslation();
  return (
    <a
      className={className}
      href={href}
      aria-label={t("accessibility.cart")}
      style={style}
      onClick={onClick}
    >
      <svg
        width="30"
        height="25"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d={CART_ICON_SVG_PATH} fill="#1E1E4F" />
        <path d={CART_CIRCLE_1} fill="#1E1E4F" />
        <path d={CART_CIRCLE_2} fill="#1E1E4F" />
      </svg>
    </a>
  );
};

export default CartIcon;
